<ng-container *ngIf="!classlist.hide">
<div [class]="classlist" [class.absolute]="display == 'absolute'" [class.fixed]="display == 'fixed' ">
    <div class="loading-spinner"><i class="fad fa-spinner-third loading-spinner"></i></div>
</div>
</ng-container>